// removed by extract-text-webpack-plugin
module.exports = {"container-funded":"_2I1b_","breakline":"_5Jqv9","timer":"_3IJ5e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Prompt/PageClosedFullyFundedSupporter/PageClosedFullyFundedSupporter.scss
// module id = ./src/components/Prompt/PageClosedFullyFundedSupporter/PageClosedFullyFundedSupporter.scss
// module chunks = 5